import React from "react";
import { withRouter } from "react-router-dom";
import GenericModifyPage from "../genericModifyPage/GenericModifyPage";
import { ClientCrudConfig } from "../multiUserManagementModifyClient/ClientCrudConfig";

function ModifyAdminPage(props) {
  const { id } = props.match.params;

  return (
    <GenericModifyPage
      id={id}
      getTitle={ClientCrudConfig.getAdminTitle}
      fetch={ClientCrudConfig.fetch}
      save={ClientCrudConfig.save}
      indexPage={ClientCrudConfig.adminIndexPage}
      itemForm={ClientCrudConfig.adminItemForm}
      validate={ClientCrudConfig.validate}
    />
  );
}

export default withRouter(ModifyAdminPage);
